import { gql } from "@apollo/client";

export const RECHAZAR_RECLAMO = gql`
    mutation rechazarReclamo($idGestionReclamo: Int!, $justificacion: String!){
        rechazoReclamo(idGestionReclamo: $idGestionReclamo, justificacion: $justificacion) {
            idGestionReclamo
        }
    }
`;